import { useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getFollowUser } from "../../../../store/actions/userActions";
import LoginModal from "../../Login/LoginModal";
import "./followers_following.scss";

function Follower({ show, close, followers, token, userData, isFollower }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showLogin, setShowLogin] = useState(false);
  const handleCloseLogin = () => setShowLogin(false);

  function handleFollow(id) {
    const data = {
      followingId: userData?.userId,
      followerId: id,
    };
    dispatch(getFollowUser(data));
  }

  return (
    <>
      <div>
        <Modal show={show} onHide={close}>
          <Modal.Header
            closeButton
            style={{ fontSize: "10px", borderBottom: "none" }}
            className="close"
          ></Modal.Header>
          <Modal.Body className="save-body">
            <div className="modal-title">
              {isFollower ? "Followers" : "Followings"}
            </div>
            {followers?.length !== 0 &&
              followers?.map((value, index) => {
                let indexfollow = userData?.userdetail?.followings?.findIndex(
                  (data) => data?.userId === value?._id
                );
                return (
                  <div
                    className="row"
                    key={index}
                    style={{ marginBottom: "-10px" }}
                  >
                    <div className="col-md-3">
                      <div
                        className="card"
                        style={{ width: "100%", border: "none" }}
                      >
                        <div className="card-body p-0">
                          <img
                            src={
                              value?.imageURL
                                ? value?.imageURL
                                : "/default/user.png"
                            }
                            alt=""
                            style={{
                              width: "80px",
                              height: "80px",
                              margin: "22px",
                              cursor: "pointer",
                              borderRadius: "10px",
                            }}
                            onClick={() => {
                              navigate(`/userprofile/${value?._id}`);
                              close();
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-9 d-flex align-items-center">
                      <div
                        className="card"
                        style={{ width: "100%", border: "none" }}
                      >
                        <div className="card-body p-0">
                          <h5
                            className="card-title"
                            style={{ fontSize: "16px" }}
                          >
                            <div>
                              <div
                                className="mt-1 Name"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  navigate(`/userprofile/${value?._id}`);
                                  close();
                                }}
                              >
                                {value?.firstName && (
                                  <span>{value?.firstName}</span>
                                )}
                                {value?.lastName && (
                                  <span className="ms-2">
                                    {value?.lastName}
                                  </span>
                                )}
                              </div>
                            </div>
                            {value?._id !== userData?.userId && token ? (
                              <div className="mt-2 d-flex align-items-center">
                                <button
                                  className="follow me-3"
                                  size="sm"
                                  onClick={() =>
                                    !token
                                      ? setShowLogin(true)
                                      : handleFollow(value?._id)
                                  }
                                >
                                  {userData &&
                                  userData?.userdetail &&
                                  userData?.userdetail?.followings[indexfollow]
                                    ?.userId === value?._id
                                    ? "Unfollow"
                                    : "Follow"}
                                </button>
                              </div>
                            ) : null}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </Modal.Body>
        </Modal>
      </div>
      <LoginModal
        show={showLogin}
        handleCloseLogin={() => handleCloseLogin()}
      />
    </>
  );
}
export default Follower;
